<template>
  <div>
    <div style="display: flex;margin:5px">
      <van-field v-model="searchValue.name" size="small" placeholder="请输入学员姓名"  clearable/>
      <van-button type="info" style="width: 80px" size="small"  block  @click="queryList">查询</van-button>
<!--      <van-field v-model="searchValue.certId"  placeholder="请输入身份证" clearable/>-->
<!--      <van-field v-model="searchValue.contactNumber"  placeholder="请输入手机号" clearable/>-->
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="item in list" :key="item.orderId" >
      <div class="showInfo" @click="openShowInfo(item)">
        <div>学员姓名：{{item.name}}</div>
<!--        <div>凭证号：{{item.insuranceNo}}</div>-->
        <div>证件号：{{item.certId}}</div>
        <div>订单状态：{{item.orderStateName}}</div>
        <div>产品名称：{{
          item.productName.indexOf("A") > -1?"学驾易(驾考服务)A": item.productName.indexOf("C") > -1?"学驾易(驾考服务)C": "学驾易(驾考服务)" }}</div>
        <div>开始日期：{{item.insuranceStartTime}}</div>
      </div>
      </van-cell>
    </van-list>
    <van-popup v-if="openShow" v-model="openShow" position="bottom" :style="{ height: '100%' }" :close-on-popstate="true" :closeable="true" >
      <el-descriptions border :column="1">
        <el-descriptions-item label="保单编号">{{ order.insuranceNo }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ order.createTime }}</el-descriptions-item>
        <el-descriptions-item label="支付时间">{{ order.payTime }}</el-descriptions-item>
        <el-descriptions-item label="产品价格">{{ order.orderFee + ' 元' }}</el-descriptions-item>
        <el-descriptions-item label="产品ID">{{ order.productId }}</el-descriptions-item>
        <el-descriptions-item label="产品名称">{{
          order.productName.indexOf("A") > -1?"学驾易(驾考服务)A": order.productName.indexOf("C") > -1?"学驾易(驾考服务)C": "学驾易(驾考服务)"     }}</el-descriptions-item>
        <el-descriptions-item label="驾校名称">{{ order.dsName }}</el-descriptions-item>
        <el-descriptions-item label="用户名">{{ order.name }}</el-descriptions-item>
        <el-descriptions-item label="证件号">{{ order.certId }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ order.contactNumber }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag size="small">{{ order.orderStateName }}</el-tag></el-descriptions-item>
        <el-descriptions-item label="保障时间" v-if="order.orderStateName == '保障中'">
          {{order.insuranceStartTime + '至' + order.insuranceEntTime}}</el-descriptions-item>
        <el-descriptions-item label="正面图片">
          <el-image
            v-if="order.positiveImage!==''"
            alt="点击预览"
            style="width: 150px; height: 50px"
            :src="order.positiveImage"
            :preview-src-list="imagesUrl">
            <div slot="error" class="image-slot imageSlot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <span v-if="order.positiveImage===''" >-</span>
        </el-descriptions-item>
        <el-descriptions-item label="反面图片">
          <el-image
            v-if="order.negativeImage!==''"
            alt="点击预览"
            style="width: 150px; height: 50px"
            :src="order.negativeImage"
            :preview-src-list="imagesUrl">
            <div slot="error" class="image-slot imageSlot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <span v-if="order.negativeImage===''" >-</span>
        </el-descriptions-item>
      </el-descriptions>
    </van-popup>
<!--    <van-dialog v-if="openShow" v-model="openShow" title="`详情`" :show-cancel-button="true" >-->
<!--    </van-dialog>-->
  </div>
</template>

<script>
  import {Config} from "../../components/common/api";
export default {
  name: "myOrders",
  data() {
    return {
      openShow:false,
      order:null,
      list: [],
      loading: false,
      finished: false,
      searchValue: {
        certId: "",
        name: "",
        orderState: "",
        payState: "",
        insuranceNo: "",
        contactNumber: "",
        currPage:0,
        productName: "",
        pageSize:20
      }, // 查询字段
      total:0,
      imagesUrl:[],
    };
  },
  mounted() {
    // this.onLoad();
  },
  methods: {
    openShowInfo(item){

     this.initData(item);
    },
    async initData(item) {
      const {data: res} = await this.$ajax({
        method: "get",
        url: Config.api_url + "applets-server/api/order/detail/" + item.orderId,
        headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')}
      });
      if (res.success) {
        this.openShow = true;
        this.order = res.data;

        if (this.order.positiveImage!=='') {
          this.imagesUrl.push(res.data.positiveImage);
        }

        if (this.order.negativeImage!=='') {
          this.imagesUrl.push(res.data.negativeImage);
        }
        if (this.order.payImage!=='') {
          this.imagesUrl.push(res.data.payImage);
        }

        // this.imagesUrl.push(res.data.flowChart);
        // console.log(this.access)
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    queryList(){
      this.searchValue.currPage = 0;
      this.list = [];
      this.onLoad()
    },
    onLoad() {
      this.searchValue.currPage = this.searchValue.currPage +1;
      let self = this;
      const url = Config.api_url + "applets-server/api/order/list";
      this.$ajax({
        method: "get",
        url: url,
        params: {
          current: self.searchValue.currPage,
          pageSize: self.searchValue.pageSize,
          contactNumber: self.searchValue.contactNumber,
          certId: self.searchValue.certId,
          name: self.searchValue.name,
          startTime: self.searchValue.startTime,
          endTime: self.searchValue.endTime,
          orderState: self.searchValue.orderState,
          payState: self.searchValue.payState,
          insuranceNo: self.searchValue.insuranceNo,
          productName: self.searchValue.productName,
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: localStorage.getItem("token"),
        },
      })
        .then(function (res) {
          const data = res.data;
          if (data.data && data.success) {
            console.log("self.loading1",data.data)
            self.list =  [...self.list,...data.data]
            self.total = data.total
            // 加载状态结束
            self.loading = false;
            console.log("self.loading",self.list)
            // 数据全部加载完成
            if (self.list.length >= self.total) {
              self.finished = true;
            }
          } else {
            self.$message({
              type: "error",
              message: data.errorMessage,
              offset: 200,
            });
          }
        })
        .catch(function (err) {
          self.$message({
            type: "error",
            message: "网络异常，请重试！",
            offset: 200,
          });
        });

    },
  },
}
</script>

<style scoped>
.showInfo{
  margin: 2px;
  padding: 10px;
  font-size: 15px;
  box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// myOrders.vue?30b64230